import React from 'react';
import * as S from './styles';

const PromoBlock = (props = {}) => (
    <S.Wrapper
        backgroundColor={props.backgroundColor}
        forceAlign={props.forceAlign}
        padding={props.padding}
    >
        {props.children}
    </S.Wrapper>
);

export default PromoBlock;
